import { useState } from 'react';
import api from '../api';

export default function CreateBlog({ onCreated }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [content, setContent] = useState('');

  const handleCreateBlog = async (e) => {
    e.preventDefault();
    try {
      await api.post('/blogs', { title, description, imageUrl, content });
      setTitle('');
      setDescription('');
      setImageUrl('');
      setContent('');
      onCreated(); // refresh parent
    } catch (err) {
      console.error('Error creating blog:', err);
    }
  };

  return (
    <form onSubmit={handleCreateBlog} className="space-y-6 bg-white dark:bg-gray-800 px-4 py-6 sm:px-6 rounded shadow-md dark:shadow-lg transition-colors">
      <h2 className="text-xl sm:text-2xl font-bold text-black dark:text-blue-400">✍️ Create New Blog</h2>

      <input
        type="text"
        placeholder="Blog Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="w-full px-3 py-2 border rounded focus:ring focus:ring-purple-300 dark:text-black"
      />

      <input
        type="text"
        placeholder="Short Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        className="w-full px-3 py-2 border rounded focus:ring focus:ring-purple-300 dark:text-black"
      />

      <input
        type="text"
        placeholder="Image URL"
        value={imageUrl}
        onChange={(e) => setImageUrl(e.target.value)}
        className="w-full px-3 py-2 border rounded focus:ring focus:ring-purple-300 dark:text-black"
      />

      <textarea
        placeholder="Full Blog Content"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={6}
        className="w-full px-3 py-2 border rounded focus:ring  dark:text-black"
      />

      <button
        type="submit"
        className="bg-lime-600 text-white px-6 py-2 rounded hover:bg-lime-700 transition dark:bg-green-500 hover:dark:bg-green-600 text-white"
      >
        Create Blog
      </button>
    </form>
  );
}